import LottieWidgetView from './LottieWidgetView.vue';
import LottieWidgetEditor from './LottieWidgetEditor.vue';

export const type = 'lottie';
export const view = LottieWidgetView;
export const editor = LottieWidgetEditor;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 200,
    width: 300,
    content: '',
    loop: true,
  };
}
